module.exports = __webpack_public_path__ + "static/media/instagram.be82168c.svg";